import type { ServiceDeskContextData } from '@atlassian/jira-navigation-types/src/types.tsx';
import { getProjectKeyOrIdFromMatchAndQuery } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-or-id/index.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_CONTEXT } from '../constants.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-context", jiraSpaEntry: "async-resource-servicedesk-context" */ './get-data'
	);

export const serviceDeskContextResource: RouteResource<ServiceDeskContextData> =
	createResource<ServiceDeskContextData>({
		type: RESOURCE_TYPE_SERVICEDESK_CONTEXT,
		getKey: ({ match, query }) => getProjectKeyOrIdFromMatchAndQuery({ match, query }),
		getDataLoader,
		maxAge: Infinity,
	});
